// Archive sort control — submit on change so the extra button isn't needed.
// The form is a plain GET, so it still works with JS off.
export function initSort(): void {
  document.querySelectorAll<HTMLFormElement>('[data-sort]').forEach((form) => {
    form.querySelector<HTMLSelectElement>('select')?.addEventListener('change', () => {
      form.submit();
    });
  });
}
